const routeNames = {
    PURCHASE_SOFTWARE: 'Product Listing',
    MY_CART: 'My Cart',
    SHIPPING_BILLING: 'Billing & Payment',
    REVIEW_ORDER: 'Review Order',
};

export default routeNames;